__turbopack_context__.v({
  "Top": "Top-module__Eg5aXq__Top",
  "active": "Top-module__Eg5aXq__active",
  "brand": "Top-module__Eg5aXq__brand",
  "brands": "Top-module__Eg5aXq__brands",
  "button": "Top-module__Eg5aXq__button",
  "changer": "Top-module__Eg5aXq__changer",
  "filterButtons": "Top-module__Eg5aXq__filterButtons",
  "icon": "Top-module__Eg5aXq__icon",
  "left": "Top-module__Eg5aXq__left",
  "name": "Top-module__Eg5aXq__name",
  "right": "Top-module__Eg5aXq__right",
});
